import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGS, CONTACT_INFO } from "@/i18n/translations";
import { extra } from "@/i18n/extra";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" && localStorage.getItem("mara-lang");
    return stored && translations[stored] ? stored : "de";
  });

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem("mara-lang", code);
    document.documentElement.lang = code;
  }, []);

  const base = translations[lang];
  const ex = extra[lang];
  const t = {
    ...base,
    cta: { ...base.cta, ...ex.cta2 },
    fresh: ex.fresh,
    market: ex.market,
    servicesMarket: ex.servicesMarket,
    request: ex.request,
    platforms: ex.platforms,
    reviews: ex.reviews,
    opening: ex.opening,
    footer: { ...base.footer, group: ex.footerGroup },
  };

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, langs: LANGS, contact: CONTACT_INFO }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
